// wiki: http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959

// 验证微信账号是否已绑定并获取cookie
export const BIND_VERIFY_ACCOUNT = 'BIND_VERIFY_ACCOUNT'
export const BIND_SET_VERIFY_ACCOUNT = 'BIND_SET_VERIFY_ACCOUNT'
// 登录以绑定微信账号
export const BIND_LOGIN_ACCOUNT = 'BIND_LOGIN_ACCOUNT'
// 注册账号查重
export const BIND_CHECK_ACCOUNT = 'BIND_CHECK_ACCOUNT'
// 发送注册验证码
export const BIND_SEND_REGISTER_MSG = 'BIND_SEND_REGISTER_MSG'
// 注册并绑定微信账号
export const BIND_REGISTER_ACCOUNT = 'BIND_REGISTER_ACCOUNT'
// 解绑微信账号
export const BIND_DELETE_ACCOUNT = 'BIND_DELETE_ACCOUNT'
// 由student_id绑定学生
export const BIND_BY_STUDENT_ID = 'BIND_BY_STUDENT_ID'
// be路由下注册
export const BIND_BY_BEROUTE = 'BIND_BY_BEROUTE'
// 仅登录不绑定微信
// export const BIND_ONLY_LOGIN_ACCOUNT = 'BIND_ONLY_LOGIN_ACCOUNT';



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/types/types_bind.js